module.exports = __webpack_public_path__ + "static/zebraonesie-3bb9db7d02066d5a313c04acbf89d43e.png";